import {
    ADD_FAVOURITE_MEMBER_SUCCESS,
    FETCH_ALL_MEMBER_SUCCESS,
    FETCH_MEMBER_SUCCESS,
    FILTER_MEMBER,
    GET_ALL_MEMBER,
    GET_UNSELECTED_ALL_MEMBER,
    HANDLE_MEMBER_REQUEST_CLOSE,
    HIDE_MEMBER_LOADER,
    SHOW_MEMBER_LOADER,
    ON_ADD_MEMBER,
    ON_EDIT_MEMBER,
    ON_ALL_MEMBER_SELECT,
    ON_MEMBER_CLOSE,
    ON_MEMBER_SELECT,
    ON_DELETE_MEMBER_SUCCESS,
    ON_FILTER_SELECTED_MEMBER,
    ON_FILTER_MEMBER_OPTION_SELECT,
    ON_SAVE_MEMBER_SUCCESS,
    ON_TOGGLE_MEMBER_DRAWER,
    SHOW_MEMBER_MESSAGE,
    UPDATE_SEARCH_MEMBER,
    CLEAR_SESSION,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All members';
export const STARRED_FILTER = 'Starred members';
export const SUCCESSFUL_UPDATE = 'Member Updated Successfully';
export const SUCCESSFUL_FILTER = 'Member Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Member Deleted Successfully';
export const REMOVED_AS_STAR = 'Member removed as star';
export const MARKED_AS_STAR = 'Member marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No members found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allMember: [],
    memberList: [],
    selectedMember: null,
    selectedMembers: 0,
    addMemberState: false,
    editMemberState: false,
    searchMember: '',
    member: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedMember: null,
            };
        }
        case ADD_FAVOURITE_MEMBER_SUCCESS: {
            const allUpdated = state.allMember.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                memberList: listUpdated,
                allMember: allUpdated,
            };
        }
        case FETCH_MEMBER_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedMember: action.payload,
                addMemberState: false,
                editMemberState: false,
            };
        }
        case FETCH_ALL_MEMBER_SUCCESS: {
            return {
                ...state,
                loader: false,
                allMember: action.payload,
                memberList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addMemberState: false,
                editMemberState: false,
            };
        }
        case SHOW_MEMBER_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_MEMBER_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedMembers = 0;
            const memberList = state.memberList.map(member => {
                if (member.selected) {
                    selectedMembers++;
                }
                if (member.id === action.payload.id) {
                    if (member.selected) {
                        selectedMembers++;
                    }
                    return action.payload;
                } else {
                    return member;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedMembers: selectedMembers,
                memberList: memberList
            };
        }
        case ON_ADD_MEMBER: {
            return {
                ...state,
                addMemberState: true,
                editMemberState: false,
            };
        }
        case ON_EDIT_MEMBER: {
            return {
                ...state,
                selectedMember: action.payload,
                editMemberState: true,
                addMemberState: false,
            };
        }
        case ON_MEMBER_CLOSE: {
            return {
                ...state,
                addMemberState: false,
                editMemberState: false,
            };
        }
        case ON_FILTER_MEMBER_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let memberList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    memberList = state.allMember;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    memberList = state.allMember.filter((member) => member.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, memberList, drawerState: false
            };
        }
        case ON_SAVE_MEMBER_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                memberList: addOrUpdateEntry(state.memberList, action.payload),
                allMember: addOrUpdateEntry(state.allMember, action.payload),
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_MEMBER_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allMember: state.allMember.filter((member) => member.id !== action.payload),
                memberList: state.allMember.filter((member) => member.id !== action.payload),
                selectedMember: null,
            };
        }
        case ON_FILTER_SELECTED_MEMBER: {
            const members = state.allMember.filter((member) => !member.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                memberList: members,
                selectedMembers: 0
            };
        }
        case FILTER_MEMBER: {
            const { filterOption } = state;
            let memberList = [];
            if (action.payload === '') {
                memberList = state.allMember;
            } else {
                const filterMember = state.allMember.filter((member) =>
                    member.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    memberList = filterMember;
                } else if (filterOption === STARRED_FILTER) {
                    memberList = filterMember.filter((member) => member.starred);
                }
            }
            return { ...state, memberList: memberList };
        }
        case GET_ALL_MEMBER: {
            let memberList = state.allMember.map((member) => member ? {
                ...member,
                selected: true
            } : member);
            return {
                ...state,
                selectedMembers: memberList.length,
                allMember: memberList,
                memberList: memberList
            };
        }
        case GET_UNSELECTED_ALL_MEMBER: {
            let memberList = state.allMember.map((member) => member ? {
                ...member,
                selected: false
            } : member);
            return {
                ...state,
                selectedMembers: 0,
                allMember: memberList,
                memberList: memberList
            };
        }
        case ON_ALL_MEMBER_SELECT: {
            const selectAll = state.selectedMembers < state.memberList.length;
            let selectedMembers = 0;
            let memberList = [];
            if (selectAll) {
                memberList = state.allMember.map((member) => member ? {
                    ...member,
                    selected: true
                } : member);
                selectedMembers = memberList.length;
            } else {
                memberList = state.allMember.map((member) => member ? {
                    ...member,
                    selected: true
                } : member);
                selectedMembers = 0;
            }
            return {
                ...state,
                selectedMembers: selectedMembers,
                allMember: memberList,
                memberList: memberList
            };
        }
        case UPDATE_SEARCH_MEMBER: {
            return { ...state, searchMember: action.payload };
        }
        case HANDLE_MEMBER_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_MEMBER_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_MEMBER_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_MEMBER_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/member.js